import { render, staticRenderFns } from "./DigiBoardsLandingPage.vue?vue&type=template&id=5d045116&scoped=true&"
import script from "./DigiBoardsLandingPage.vue?vue&type=script&lang=js&"
export * from "./DigiBoardsLandingPage.vue?vue&type=script&lang=js&"
import style0 from "./DigiBoardsLandingPage.vue?vue&type=style&index=0&id=5d045116&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d045116",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCol,VContainer,VIcon})
